import $ from 'jquery';
window.jQuery = $;
require('slider-pro')

function SliderProCtrl() {
  this.$target = $('#slider-pro-1')

  this.init();
}

SliderProCtrl.prototype.init = function () {
  this.$target.sliderPro({
    width: 960,
    height: 320,
    autoHeight: true,
    // slideAnimationDuration: 1000,
    fade: true,
    fadeDuration: 3000,
    autoplayDelay: 8000,
    arrows: true,
    buttons: false,
    reachVideoAction: 'playVideo',
    leaveVideoAction: 'none',
    playVideoAction: 'none',
    endVideoAction: 'replayVideo',
    thumbnailImageSize: 'mio-slider-thumb',
    thumbnailWidth: 142,
    thumbnailHeight: 88,
    thumbnailPointer: true,
    thumbnailsPosition: 'bottom'
  });
}

export default SliderProCtrl;